
const capsFirstLetter = (str) => {
   return str?.charAt(0).toUpperCase() + str?.slice(1);
};

function LogOut(PATH) {
   localStorage.clear(); // Clear expiry time on logout
   window.location.href = PATH;
}

function checkLogout() {
    const token = localStorage.getItem('access_token');
    const expiresIn = localStorage.getItem('expires_in');
    const loginTime = localStorage.getItem('loginTime');
    
    if (!token) {
        console.warn('No token found for auto-logout check.');
        return;
    }
    
    if (!expiresIn) {
        console.warn('No expiration time found for auto-logout check.');
        return;
    }
    
    if (loginTime) {
        const loginTimestamp = new Date(loginTime).getTime();
        const currentTime = Date.now();
        const elapsedTime = currentTime - loginTimestamp;
        
        // expiresIn is in seconds, convert to milliseconds
        const totalExpireTime = parseInt(expiresIn) * 1000;
        const remainingTime = totalExpireTime - elapsedTime;
        
        // console.log('Advertiser token expiration check:', {
        //     loginTime,
        //     currentTime,
        //     elapsedTime,
        //     totalExpireTime,
        //     remainingTime,
        //     expired: remainingTime <= 0
        // });
        
        if (remainingTime <= 0) {
            // console.log('Advertiser token expired, logging out...');
            LogOut(); // Logout if expiry time has passed
        }
    } else {
        // If no loginTime is found, set it
        const currentLoginTime = new Date().toISOString();
        localStorage.setItem('loginTime', currentLoginTime);
        // console.log('Set advertiser login time:', currentLoginTime);
    }
}

// Call checkLogout periodically, for example every hour
setInterval(checkLogout, 1000 * 60 * 60); // Check every hour


export { capsFirstLetter, LogOut }